import { all, fork } from 'redux-saga/effects';

import watchCustomerCepAddressRequest from './customerAddressCepRequest';
import watchCustomerAddressRequest from './customerAddressRequest';
import watchCustomerChangePassword from './customerChangePassword';
import watchCustomerDocRequest from './customerDocRequest';
import watchCustomerDocsEnumRequest from './customerDocsEnumRequest';
import watchCustomerInfosRequest from './customerInfosRequest';
import watchCustomerMailsRequest from './customerMailsRequest';
import watchCustomerOrderAddressRequest from './customerOrderAddressRequest';
import watchCustomerOrderFreightRequest from './customerOrderFreightRequest';
import watchCustomerOrderInfosRequest from './customerOrderInfosRequest';
import watchCustomerOrderPaymentRequest from './customerOrderPaymentRequest';
import watchCustomerOrderProductsRequest from './customerOrderProductsRequest';
import watchCustomerOrdersRequest from './customerOrdersRequest';
import watchCustomerPhonesRequest from './customerPhonesRequest';
import watchLoginRequest from './loginRequest';
import watchRegisterRequest from './registerRequest';
import watchRescuePasswordRequest from './rescuePasswordRequest';

function* customerSagas() {
  yield all([
    fork(watchLoginRequest),
    fork(watchRegisterRequest),
    fork(watchCustomerInfosRequest),
    fork(watchCustomerMailsRequest),
    fork(watchCustomerOrdersRequest),
    fork(watchCustomerPhonesRequest),
    fork(watchRescuePasswordRequest),
    fork(watchCustomerAddressRequest),
    fork(watchCustomerChangePassword),
    fork(watchCustomerOrderInfosRequest),
    fork(watchCustomerOrderAddressRequest),
    fork(watchCustomerOrderFreightRequest),
    fork(watchCustomerOrderPaymentRequest),
    fork(watchCustomerOrderProductsRequest),
    fork(watchCustomerCepAddressRequest),
    fork(watchCustomerDocsEnumRequest),
    fork(watchCustomerDocRequest),
  ]);
}

export default customerSagas;
